import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Prevents authenticated users from accessing public pages (login, register).
 * Redirects to /dashboard if already logged in.
 */
export const noAuthGuard: CanActivateFn = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    const authenticated = await authService.isAuthenticated();
    if (authenticated) {
      return router.createUrlTree(['/dashboard']);
    }
  } catch {
    // Not authenticated — allow access
  }

  return true;
};
